export * from "./all-users.component";
export * from "./all-users.module";


// WEBPACK FOOTER //
// ./src/app/admin/all-users/index.ts